var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"background-page"},[_c('p',{staticClass:"background-name"},[_vm._v("背景分析")]),_c('div',{staticClass:"background-content-box"},[_c('div',{staticClass:"content-item",attrs:{"id":"education"}}),_c('div',{staticClass:"content-item",attrs:{"id":"work"}}),_c('div',{staticClass:"content-item",attrs:{"id":"salary"}})])])
}]

export { render, staticRenderFns }